<template>
    <div v-if="hasErrors" class="is-danger m-b-md" role="alert" aria-live="polite">
        <ul>
            <li v-for="(error, index) in errorList" :key="index">
                <span v-if="showFieldNames && error.field && !Number.isInteger(parseInt(error.field))">
                    <strong>{{ formatFieldName(error.field) }}</strong>: 
                </span>{{ error.message }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'ValidationErrors',

    props: {
        validationErrors: {
            type: [Array, Object],
            required: true,
        },
        showFieldNames: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        hasErrors() {
            if (!this.validationErrors) return false;

            if (Array.isArray(this.validationErrors)) {
                return this.validationErrors.length > 0;
            }

            return Object.keys(this.validationErrors).length > 0;
        },

        errorList() {
            if (!this.validationErrors) return [];

            // Handle array format (simple list of error messages)
            if (Array.isArray(this.validationErrors)) {
                return this.validationErrors.map(message => ({
                    field: null,
                    message,
                }));
            }

            // Handle object format (field -> messages mapping)
            const errors = [];
            Object.entries(this.validationErrors).forEach(([field, messages]) => {
                if (Array.isArray(messages)) {
                    messages.forEach(message => {
                        errors.push({
                            field,
                            message,
                        });
                    });
                } else if (messages) {
                    // Handle case where message is not an array
                    errors.push({
                        field,
                        message: messages,
                    });
                }
            });

            return errors;
        },

        // Keep the old computed property for backward compatibility
        flatErrors() {
            if (!this.validationErrors) return [];
            return this.errorList.map(error => error.message);
        },
    },

    methods: {
        formatFieldName(field) {
            // Convert snake_case, dot.notation, and camelCase to readable format
            return field
                .replace(/[._]/g, ' ') // Replace dots and underscores with spaces
                .replace(/([a-z])([A-Z])/g, '$1 $2') // Split camelCase
                .replace(/\b\w/g, l => l.toUpperCase()); // Capitalize each word
        },
    },
};
</script>
